import {PktButton} from "@oslokommune/punkt-react";
import {config} from "../../environment";
import {getPrissoknadKvitteringPdf} from "../../api/prissoknader";
import styles from "./styles.module.scss";

type Props = {
    brukerref: string;
};

const DownloadPdfLink = ({brukerref}: Props) => {

    const downloadFile = async (brukerref: string, fileName: string) => {
        const response = await getPrissoknadKvitteringPdf(
            `${config.apiUrl}/api/pris-soknad-pdf/` + brukerref
        );
        const responseBlob = await response.blob();

        const element = document.createElement("a");
        element.href = URL.createObjectURL(responseBlob);
        element.download = fileName;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    };

    return (
        <>
            <PktButton
              size={'small'}
              iconName={'download'}
              skin={'tertiary'}
              variant={'icon-left'}
              className={styles.uploadButton}
                onClick={() => {
                    downloadFile(brukerref, `Søknad om redusert barnehagepris ${brukerref}.pdf`);
                }}
            >
                Last ned kvittering
            </PktButton>
        </>

    );
};


export default DownloadPdfLink;
